// needs to be in sync with container.css
export const spacer = 16
export const maxWidth = 1312
